import styled from "styled-components";

const SupportAppointmentStyles = styled.div`
  .support-container {
    ${props => props.theme.media.lg} {
      margin-top: 16px;
    }
  }

  .video-container {
    margin-top: 32px;
    margin-bottom: 16px;
    video {
      width: 100%;
      max-width: 789px;
    }
  }

  .title {
    display: none;

    ${props => props.theme.media.lg} {
      display: block;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 36px;
      line-height: 48px;
      color: rgba(18, 23, 36, 0.91);
      max-width: 660px;
    }
  }

  .description {
    p {
      margin-top: 16px;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.01px;
      font-feature-settings: 'ss01' on, 'ss02' on, 'ss04' on;
      color: rgba(18, 23, 36, 0.91);

      ${props => props.theme.media.lg} {
        font-size: 16px;
        line-height: 24px;
        max-width: 676px;
      }
    }
  }

  .btn {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.01em;
    font-feature-settings: 'ss01' on, 'ss02' on, 'ss04' on;
    color: #FFFFFF;

  }
`;

export default SupportAppointmentStyles;